import { Dispatch } from "react";
import { ClaimQueryParamsState, ClaimQueryStateActionType } from "src/pages/copayClaimsHCP/types";



export type CopaylaimsFilterProps = {
  activeTabName : any;
  state: ClaimQueryParamsState;
  dispatch: Dispatch<ClaimQueryStateActionType>;
  handleSearchWithQueryParam: (updatedState: ClaimQueryParamsState) => void;
  onClearButtonClicked: () => void;
};
export const CLAIM_STATUS = [
  {
    value: "12",
    label: "Submitted",
  },
  {
    value: "22",
    label: "Approved",
  },
  {
    value: "31",
    label: "Denied",
  },
];
